import { Button, Box } from '@mui/material'; // Ensure Button is imported
import { styled } from '@mui/material/styles';

export const ActionContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
}));

export const EndShiftButton = styled(Button)(({ theme }) => ({
  width: '100%',
  backgroundColor: '#FFEBEE', // Light pink/red background
  color: '#D32F2F', // Strong red text
  fontWeight: 600,
  fontSize: '1rem',
  textTransform: 'none',
  padding: theme.spacing(1.5),
  borderRadius: '8px',
  boxShadow: 'none',
  transition: 'all 0.2s',
  '&:hover': {
    backgroundColor: '#FFCDD2', // Slightly darker pink on hover
    boxShadow: 'none',
  },
  '&:active': {
    backgroundColor: '#EF9A9A',
  },
}));